import { render } from "./Logos.vue?vue&type=template&id=3306a917"
import script from "./Logos.vue?vue&type=script&lang=js"
export * from "./Logos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__